{
  "pending": "Ausstehend",
  "delivered": "Geliefert",
  "retry": "Wiederholen",
  "error": "Fehlgeschlagen",
  "cancelling": "Wird abgebrochen",
  "cancelled": "Abgebrochen",
  "paused": "Pausiert",
  "done": "Fertig",
  "running": "Wird ausgeführt",
  "expired": "Abgelaufen",
  "dateFormat": "YYYY/MM/DD [um] hh:mm A",
  "operationType": {
    "CRTCLT_RENEWAL_DVC": "Zertifikatverlängerung",
    "CRTCLT_RENEWAL_APP": "Zertifikatverlängerung",
    "FIRMWARE_UPGRADE_DVC": "Firmware-Upgrade"
  },
  "type": "Vorgangstyp",
  "createdAt": "Erstellt am",
  "launchedAt": "Geplantes Startdatum",
  "updatedAt": "Aktualisiert am",
  "state": "Betriebsstatus",
  "certificate": {
    "update": {
      "label": "Zertifikatverlängerung",
      "dateTimeError": "Für die Aktualisierung des Zertifikats sind Datum und Uhrzeit erforderlich.",
      "plannedStartAt": {
        "label": "Vorgang konfigurieren",
        "placeholder": "Aktualisierungsdatum auswählen"
      },
      "dateNotValidAfterRenewal": "Das Datum muss vor Ablauf des Zertifikats gültig sein"
    }
  },
  "firmware": {
    "update": {
      "label": "Firmware aktualisieren",
      "description": "Datum- und Zeitparameter sind erforderlich, um das Update der Firmware {name} zu starten.",
      "firmwareLabel": "Firmware",
      "uuidRequired": "Die Firmware ist erforderlich",
      "plannedStartAt": "Datum und Uhrzeit der Firmware-Aktualisierung (YYYY/MM/DD HH:MM)",
      "notaBene": "Die Aktualisierung der Firmware wird während der nächsten Kommunikation mit dem {name} ab dem Datum und der Uhrzeit der Firmware-Aktualisierung durchgeführt.",
      "dateTimeError": "Für die Aktualisierung der Firmware sind Datum und Uhrzeit erforderlich",
      "warningMessage": "Warnung: Die Aktualisierung der Firmware führt am Ende des Updates zum Neustart des zugehörigen Geräts.",
      "version": "Version",
      "dtwin": {
        "description": "Konfigurieren Sie den Firmware-Update-Vorgang.",
        "launchPlannedAt": "Aktualisierungsdatum",
        "validation": {
          "launchPlannedAt": "Das Aktualisierungsdatum ist erforderlich."
        },
        "startsAtCreation": "Übertragung des Vorgangs an das Gerät so bald wie möglich",
        "firmware": "Eine Firmware aus der Liste unten auswählen"
      },
      "scheduled": {
        "warningMessage": "Das Gerät hat bereits einen geplanten, ausstehenden oder laufenden Vorgang desselben Typs"
      }
    }
  },
  "dateInferiorToToday": "Das Datum darf nicht früher als das heutige Datum/die jetzige Uhrzeit sein",
  "empty": "Keine Vorgänge gefunden",
  "actions": "Aktionen",
  "queued": "In der Warteschlange",
  "failed": "Fehlgeschlagen",
  "unknown": "Unbekannter Status",
  "scheduled": "Geplant",
  "configuration": {
    "selfSupportingVersion": "Eigenständige Version",
    "globalVersion": "Globale Version",
    "specificVersion": "Spezifische Version",
    "updatedDate": "Aktualisierungsdatum"
  },
  "unitary": {
    "title": "Einzeln"
  },
  "campaign": {
    "title": "Kampagne"
  },
  "trigger": {
    "title": "Auslöser",
    "AUTO": "Automatisch",
    "MANUAL": "Manuell"
  },
  "on_hold": "Angehalten"
}
